module.exports = __webpack_public_path__ + "img/parking_9a921a3.webp";